import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between sm:col-span-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-right"
}
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "inline text-gray-700 font-bold" }
const _hoisted_5 = { class: "sm:pr-4 mt-6 border-t border-gray-900/5 pt-6" }
const _hoisted_6 = { class: "inline text-gray-700 font-bold" }
const _hoisted_7 = { class: "sm:pl-4 sm:mt-6 sm:border-t sm:border-gray-900/5 sm:pt-6" }
const _hoisted_8 = {
  key: 0,
  class: "inline text-gray-700 font-bold"
}
const _hoisted_9 = {
  key: 1,
  class: "inline text-gray-700 font-bold"
}
const _hoisted_10 = { class: "mt-6 sm:border-t sm:border-gray-900/5 sm:pt-6 sm:col-span-2" }
const _hoisted_11 = { class: "mt-6 sm:border-t sm:border-gray-900/5 sm:pt-6 sm:col-span-2" }
const _hoisted_12 = { class: "mt-8 flex flex-row items-center justify-end gap-3 *:w-full sm:flex-row sm:*:w-auto" }
const _hoisted_13 = ["href"]

import api from '@/utilities/api'

	import {
		ArrowDownTrayIcon,
		ArrowUpRightIcon,
	} from "@heroicons/vue/20/solid"

	import {
		Invoice
	} from '@/types'

	import {
		isDueOnReceipt as isInvoiceDueOnReceipt,
		showStatusBadge as isStatusBadgeVisible,
		invoiceStatusColor as invoiceBadgeColor,
		invoiceStatusLabel as invoiceBadgeLabel
	} from '@/utilities/invoiceStatus'

	import {		
		Auth
	} from 'aws-amplify'

	import {
		computed,
		ref,
		PropType
	} from 'vue'

	
	const __default__ = { name: 'InvoiceDetailsButton' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
		invoice: {
			type: Object as PropType<Invoice>,
			default: () => {return {} as Invoice}
		},
	},
  setup(__props) {

	const props = __props

	const invoiceDetailsModal = ref<{open: boolean}>({open: false})
	const initialFocusTarget = ref<HTMLElement | null>(null)

	const currencyFormatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	})

	const openDialog = () => {
		invoiceDetailsModal.value.open = true
	}
	
	const invoiceStatusColor = computed(() => invoiceBadgeColor(props.invoice))

	const invoiceStatusLabel = computed(() => invoiceBadgeLabel(props.invoice))

	const isDueOnReceipt = computed(() => isInvoiceDueOnReceipt(props.invoice.paymentTerms))

	const showStatusBadge = computed(() => isStatusBadgeVisible(props.invoice))

	const servicesWithoutProcessingFees = computed(() => {
		return props.invoice.services.filter((s: {description: string, total: number}) => {
			return !s.description.toLowerCase().includes('processing fee')
		})
	})

	const downloadLoading = ref(false)
	async function downloadInvoice() {
		try {
			downloadLoading.value = true
			const user = await Auth.currentAuthenticatedUser()

			const body = {
				action: "downloadInvoice",
				payload: {
					id: props.invoice.id,
					companyID: user.attributes['custom:fm_company_id']
				}
			}
			const response = await api("post", "fmDataAPI", "/fmDataAPI", body)
			const scriptResult = JSON.parse(response.response.scriptResult)

			if(scriptResult?.messages?.code !== 0){
				throw scriptResult?.messages
			}

			const base64 = scriptResult.result.data
			const byteCharacters = atob(base64)
			const byteNumbers = new Array(byteCharacters.length)
			for(let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i)
			}
			const byteArray = new Uint8Array(byteNumbers)
			const blob = new Blob([byteArray], {type: "application/pdf"})

			const url = URL.createObjectURL(blob)
			const link = document.createElement("a")
			link.href = url
			link.download = `DB Services Invoice #${props.invoice.invoiceNumber}.pdf`
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			URL.revokeObjectURL(url)
		}
		catch(e) {
			console.error(e)
			alert("Unable to download invoice. Please try again.")
		}
		finally {
			downloadLoading.value = false
		}
	}

	function invoiceTotalWithoutProcessingFee(invoice: any) {
		
		const processingFee = invoice.services.filter((s: {description: string, total: number}) => {
			return s.description?.toLowerCase().includes('processing fee')
		})

		const amountDue = +invoice.total - (processingFee.length > 0 ? processingFee[0].total : 0)
		
		if (amountDue < 0) {
			return 0
		}

		return amountDue 
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_simple_stat = _resolveComponent("tw-simple-stat")!
  const _component_tw_badge_flat = _resolveComponent("tw-badge-flat")!
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: openDialog,
      class: "link"
    }, " View Details "),
    _createVNode(_component_tw_modal, {
      title: `Invoice #${ props.invoice.invoiceNumber }`,
      "modal-max-width": "max-w-screen-sm",
      "initial-focus": initialFocusTarget.value,
      ref_key: "invoiceDetailsModal",
      ref: invoiceDetailsModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("dl", {
          ref_key: "initialFocusTarget",
          ref: initialFocusTarget,
          tabindex: "-1",
          class: "mt-6 grid grid-cols-1 text-sm leading-6 sm:grid-cols-2"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createVNode(_component_tw_simple_stat, { label: "Invoice Total" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(currencyFormatter).format(invoiceTotalWithoutProcessingFee(props.invoice))), 1)
                ]),
                _: 1
              })
            ]),
            (showStatusBadge.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_tw_badge_flat, { color: invoiceStatusColor.value }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(invoiceStatusLabel.value), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  _createElementVNode("div", _hoisted_3, [
                    _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "inline text-gray-500" }, " Payment Terms ", -1)),
                    _cache[2] || (_cache[2] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
                    _createElementVNode("dd", _hoisted_4, _toDisplayString(props.invoice.paymentTerms), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "inline text-gray-500" }, " Invoiced on ", -1)),
            _cache[4] || (_cache[4] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
            _createElementVNode("dd", _hoisted_6, [
              _createElementVNode("time", null, _toDisplayString(props.invoice.invoiceDate), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("dt", { class: "inline text-gray-500" }, " Due on ", -1)),
            _cache[7] || (_cache[7] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
            (!isDueOnReceipt.value)
              ? (_openBlock(), _createElementBlock("dd", _hoisted_8, [
                  _createElementVNode("time", null, _toDisplayString(props.invoice.dueDate), 1)
                ]))
              : (_openBlock(), _createElementBlock("dd", _hoisted_9, _cache[5] || (_cache[5] = [
                  _createElementVNode("time", null, "Receipt", -1)
                ])))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[8] || (_cache[8] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, " Summary ", -1)),
            _createElementVNode("dd", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.invoice.summaries, (item, idx) => {
                return (_openBlock(), _createElementBlock("p", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[9] || (_cache[9] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, " Services ", -1)),
            _createElementVNode("dd", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(servicesWithoutProcessingFees.value, (service, idx) => {
                return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(service.description), 1))
              }), 128))
            ])
          ])
        ], 512),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_tw_button, {
            class: "btn-base btn-indigo w-full",
            loading: downloadLoading.value,
            disabled: downloadLoading.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadInvoice()))
          }, {
            icon_right: _withCtx(() => [
              _createVNode(_unref(ArrowDownTrayIcon), { class: "w-5 h-5" })
            ]),
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createTextVNode(" Download Invoice "))
            ]),
            _: 1,
            __: [10]
          }, 8, ["loading", "disabled"]),
          (props.invoice.status === 'Paid' && props.invoice.receipt)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: props.invoice.receipt,
                target: "_blank"
              }, [
                _createVNode(_component_tw_button, { class: "btn-base btn-indigo w-full" }, {
                  icon_right: _withCtx(() => [
                    _createVNode(_unref(ArrowUpRightIcon), { class: "w-5 h-5" })
                  ]),
                  default: _withCtx(() => [
                    _cache[11] || (_cache[11] = _createTextVNode(" View Receipt "))
                  ]),
                  _: 1,
                  __: [11]
                })
              ], 8, _hoisted_13))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["title", "initial-focus"])
  ], 64))
}
}

})